import { Routes, Route } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import WhyChooseUs from './components/WhyChooseUs';
import ServiceAreas from './components/ServiceAreas';
import Pricing from './components/Pricing';
import Process from './components/Process';
import MovingTips from './components/MovingTips';
import Team from './components/Team';
import Testimonials from './components/Testimonials';
import FAQ from './components/FAQ';
import Contact from './components/Contact';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import WhatsAppButton from './components/WhatsAppButton';
import VideoCallButton from './components/VideoCallButton';
import StructuredData from './components/StructuredData';
import CookieBanner from './components/CookieBanner';

const Datenschutz = lazy(() => import('./pages/Datenschutz'));
const AGB = lazy(() => import('./pages/AGB'));
const Impressum = lazy(() => import('./pages/Impressum'));
const UmzugZurichDeutschland = lazy(() => import('./pages/UmzugZurichDeutschland'));
const UmzugBaselDeutschland = lazy(() => import('./pages/UmzugBaselDeutschland'));
const UmzugBernDeutschland = lazy(() => import('./pages/UmzugBernDeutschland'));
const UmzugLuzernDeutschland = lazy(() => import('./pages/UmzugLuzernDeutschland'));
const UmzugAargauDeutschland = lazy(() => import('./pages/UmzugAargauDeutschland'));
const UmzugWinterthurDeutschland = lazy(() => import('./pages/UmzugWinterthurDeutschland'));
const UmzugStGallenDeutschland = lazy(() => import('./pages/UmzugStGallenDeutschland'));
const UmzugZugDeutschland = lazy(() => import('./pages/UmzugZugDeutschland'));
const Teilumzug = lazy(() => import('./pages/Teilumzug'));
const Zollabwicklung = lazy(() => import('./pages/Zollabwicklung'));
const Komplettumzug = lazy(() => import('./pages/Komplettumzug'));
const Verpackungsmaterial = lazy(() => import('./pages/Verpackungsmaterial'));
const Zwischenlagerung = lazy(() => import('./pages/Zwischenlagerung'));
const Endreinigung = lazy(() => import('./pages/Endreinigung'));
const Firmenumzuege = lazy(() => import('./pages/Firmenumzuege'));
const ExpressUmzuege = lazy(() => import('./pages/ExpressUmzuege'));
const Leistungen = lazy(() => import('./pages/Leistungen'));
const Preise = lazy(() => import('./pages/Preise'));
const Ablauf = lazy(() => import('./pages/Ablauf'));
const FAQPage = lazy(() => import('./pages/FAQ'));
const Kontakt = lazy(() => import('./pages/Kontakt'));
const SofortBesichtigung = lazy(() => import('./pages/SofortBesichtigung'));
const ThankYou = lazy(() => import('./pages/ThankYou'));
const OfferteAnfordern = lazy(() => import('./pages/OfferteAnfordern'));
const Sitemap = lazy(() => import('./pages/Sitemap'));

function HomePage() {
  return (
    <>
      <Hero />
      <Services />
      <WhyChooseUs />
      <ServiceAreas />
      <Pricing />
      <Process />
      <MovingTips />
      <Team />
      <Testimonials />
      <FAQ />
      <Contact />
    </>
  );
}

function App() {
  return (
    <div className="min-h-screen">
      <StructuredData />
      <Header />
      <main className="pt-[120px]">
        <Suspense fallback={<div className="flex items-center justify-center min-h-screen"><div className="animate-spin rounded-full h-12 w-12 border-b-2 border-slate-900"></div></div>}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/umzug-zuerich-deutschland" element={<UmzugZurichDeutschland />} />
            <Route path="/umzug-basel-deutschland" element={<UmzugBaselDeutschland />} />
            <Route path="/umzug-bern-deutschland" element={<UmzugBernDeutschland />} />
            <Route path="/umzug-luzern-deutschland" element={<UmzugLuzernDeutschland />} />
            <Route path="/umzug-aargau-deutschland" element={<UmzugAargauDeutschland />} />
            <Route path="/umzug-winterthur-deutschland" element={<UmzugWinterthurDeutschland />} />
            <Route path="/umzug-stgallen-deutschland" element={<UmzugStGallenDeutschland />} />
            <Route path="/umzug-zug-deutschland" element={<UmzugZugDeutschland />} />
            <Route path="/teilumzug" element={<Teilumzug />} />
            <Route path="/zollabwicklung" element={<Zollabwicklung />} />
            <Route path="/komplettumzug" element={<Komplettumzug />} />
            <Route path="/verpackungsmaterial" element={<Verpackungsmaterial />} />
            <Route path="/zwischenlagerung" element={<Zwischenlagerung />} />
            <Route path="/endreinigung" element={<Endreinigung />} />
            <Route path="/firmenumzuege" element={<Firmenumzuege />} />
            <Route path="/express-umzuege" element={<ExpressUmzuege />} />
            <Route path="/leistungen" element={<Leistungen />} />
            <Route path="/preise" element={<Preise />} />
            <Route path="/ablauf" element={<Ablauf />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/kontakt" element={<Kontakt />} />
            <Route path="/sofort-besichtigung" element={<SofortBesichtigung />} />
            <Route path="/offerte-anfordern" element={<OfferteAnfordern />} />
            <Route path="/danke" element={<ThankYou />} />
            <Route path="/datenschutz" element={<Datenschutz />} />
            <Route path="/agb" element={<AGB />} />
            <Route path="/impressum" element={<Impressum />} />
            <Route path="/sitemap" element={<Sitemap />} />
          </Routes>
        </Suspense>
      </main>
      <Footer />
      <ScrollToTop />
      <VideoCallButton />
      <WhatsAppButton />
      <CookieBanner />
    </div>
  );
}

export default App;
